const toHttpUrl = (value?: string | null, baseHref?: string) => {
    if (!value) {
        return undefined;
    }

    try {
        const url = new URL(value, baseHref);

        return url.protocol === 'http:' || url.protocol === 'https:' ? url.toString() : undefined;
    } catch {
        return undefined;
    }
};

const normalizeReferenceText = (value?: string | null) => value?.replace(/\s+/g, ' ').trim();

const trimTrailingPartialWord = (value: string) => value.replace(/\s+\S*$/, '').trim() || value.trim();

const trimLeadingPartialWord = (value: string) => value.replace(/^\S*\s+/, '').trim() || value.trim();

const getTextDirective = (referenceText: string) => {
    if (referenceText.length <= 160) {
        return encodeURIComponent(referenceText);
    }

    const start = trimTrailingPartialWord(referenceText.slice(0, 96));
    const end = trimLeadingPartialWord(referenceText.slice(-96));

    return `${encodeURIComponent(start)},${encodeURIComponent(end)}`;
};

const addTextFragment = (sourceUrl: string, referenceText?: string | null) => {
    const normalizedReferenceText = normalizeReferenceText(referenceText);

    if (!normalizedReferenceText) {
        return sourceUrl;
    }

    const url = new URL(sourceUrl);
    const existingAnchor = url.hash.slice(1).split(':~:')[0];
    const textDirective = `:~:text=${getTextDirective(normalizedReferenceText)}`;

    url.hash = `${existingAnchor}${textDirective}`;

    return url.toString();
};

export const getFilingSourceTruthUrl = (href?: string | null, baseHref = window.location.href) => {
    const citationUrl = toHttpUrl(href, baseHref);

    if (!citationUrl) {
        return undefined;
    }

    const parsedCitationUrl = new URL(citationUrl);
    const embeddedFilingUrl = toHttpUrl(parsedCitationUrl.searchParams.get('filingUrl'), baseHref);
    const embeddedSourceDocumentUrl = toHttpUrl(parsedCitationUrl.searchParams.get('sourceDocumentUrl'), baseHref);

    if (embeddedFilingUrl) {
        return addTextFragment(embeddedFilingUrl, parsedCitationUrl.searchParams.get('filingText'));
    }

    if (embeddedSourceDocumentUrl) {
        return addTextFragment(embeddedSourceDocumentUrl, parsedCitationUrl.searchParams.get('sourceDocumentText'));
    }

    return parsedCitationUrl.origin !== new URL(baseHref).origin ? citationUrl : undefined;
};

export const isPublicMemoPath = (pathname: string) => /^\/(?:s|shared)\/memos\/[^/]+/.test(pathname);
